export const FileUploadMegabyteLimit = 15;
export const FileUploadLimit = FileUploadMegabyteLimit * (1024 * 1024); // 15 mb
export const UserEligibleMinimumAge = 18;
export const FILE_CACHE_LIFETIME = 12000;
